import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { lookupActionCreators } from '..';
import { IState } from '../..';
import { showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../lookupsApi';
import { getNonLoadedLookups } from '../lookupsSelectors';

function* fetchOnDemandLookupsSaga(action: ReturnType<typeof lookupActionCreators.fetchOnDemandLookups>) {
  // only fetch things that aren't currently loaded
  const toLoad = yield* select((state: IState) => getNonLoadedLookups(state, action.payload.types));

  if (toLoad.length > 0) {
    const response = yield* call(api.FetchOnDemandLookups, toLoad);

    if (response.requestFailed) {
      yield showFailedRequestDialog(response);
    } else if (response.value) {
      yield put(lookupActionCreators.setLookups({ payload: response.value }));
    } else {
      yield put(lookupActionCreators.removeLoading(toLoad));
    }
  }
}

export function* watchFetchOnDemandLookups() {
  yield takeEvery(lookupActionCreators.fetchOnDemandLookups.match, fetchOnDemandLookupsSaga);
}
